import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';

//Funciones
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const dataListaChequeo = functionsHttpsCallable('ape_getDataListaChequeo');
const envioCorreoLider = functionsHttpsCallable('correos_envioCorreoDocContractuales');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalSeguridadSocial = (props) => {
    const [loading, setLoading] = useState(true);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [dataLista, setDataLista] = useState(undefined); 

    useEffect(() => {
        console.log('acaaa', props);
        async function ape_getDataListaChequeo() {
            setLoading(true);
            const req = await dataListaChequeo({
                "cod_empr": 537,
                "ape": props.id
            })
            console.log('request', req.data);
            if (req.data.data[0]) setDataLista(req.data.data[0])
            setLoading(false);
        };
        ape_getDataListaChequeo();
    }, [])


    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    const handleUpdate = async () => {
        const body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cod_actu: props.data.flujo.cedulaCargaDocumentos ? props.data.flujo.cedulaCargaDocumentos : props.data.flujo.cedulaPrimerAprobador,
                cmp_stat: 'CARGA_CONTRATO'
            }
        }
        const req = await actualizarAPE(body)
        let bodyCorreo = {
            enviarA: [props.data.flujo.emailCargaDocumentos, props.data.flujo.emailPrimerAprobador, props.data.flujo.emailTercerAprobador, 'auxiliar.desarrollo@confipetrol.com', 'gestor.desarrollo@confipetrol.com'],
            enviarACC: [],
            codigoAPE: props.id,
            nombre: dataLista?.nombre ?? 'test',
            cargo: props.data.codigoCargo,
            fechaIngreso: new Date(props.data.fechaContratacionLider._seconds * 1000).toISOString().split('T')[0],
            campo: props.data.campo,
            cedula: dataLista?.cedula ?? 'test',
            correo: dataLista?.correo ??'test',
            adjuntos: []
        }
        try {
            await envioCorreoLider(bodyCorreo)
            props.toastSuccess('Correo enviado');
        }
        catch (error) {
            console.log(error)
            props.toastError('Error envio del correo')
        }
        props.toggle();
        props.setLoading(false)
        props.toastSuccess('Estado Actualizado!');
    }

    useEffect(() => {
    }, [])

    const listadoAdjuntos = [
        {
            name: 'Afiliación EPS',
            key: 'EPS',
        },
        {
            name: 'Afiliación Caja de Compensación',
            key: 'CAJA_DE_COMPENSACION',
        },
        {
            name: 'Afiliación Fondo de Pensiones',
            key: 'FONDO_PENSIONES',
        },
        {
            name: 'Afiliación ARL',
            key: 'ARL',
        },
        {
            name: 'Afiliación Cesantías',
            key: 'CESANTIAS',
        },
        {
            name: 'Manual de funciones',
            key: 'MANUAL_FUNCIONES_1',
        },
        {
            name: 'Contrato',
            key: 'CONTRATO',
        }
    ]

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Actualizar'}
                onClick={() => handleUpdate()}
                buttonLoading={false}
                title={`Documentos Seguridad Social`}
            >
                {loading ? <div className={"loading-area"}> <Loading /> </div> : <Row>
                    {listadoAdjuntos.map((doc, index) => {
                        return (
                            <Col key={`col1_${index}`} lg='3' md='6' xs="12">
                                <AttachCardV2
                                    id={`${doc.key}`}
                                    subText={`${doc.name}`}
                                    attached={fileExist(`${doc.key}`).exists}
                                    file={fileExist(doc.key).file}
                                    apeId={props.id}
                                    fileList={props.fileList}
                                    setLoading={(e) => props.setLoading(e)}
                                    setFileList={(e) => { props.setFileList(e) }}
                                />
                            </Col>

                        )
                    })}
                </Row>}

            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalSeguridadSocial);